
import { OrderService } from "src/services";
import { Toast } from "vant";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";


@Component
export default class PersonalPage extends Vue
{
    // 用于刷新子组件
    private keyNum: any = 0;

    // 样式
    private pageStyle: any = {};

    /**
     * 是否显示权益中心
     * @private
     * @returns boolean
     */
    private hasRights: boolean = false;

    /**
     * 父组件传值
     * @private
     * @returns object
     */
    @Prop({type: Object, default: {}})
    private data: {};

    // 是否展示权益
    private created () {
        if(localStorage.getItem("userInfo"))
        {
            this.getOrderQuantity();
        }
     }

    // 主标题字体大小
    private titleText: any = {};

    // 副标题字体大小
    private subTitleText: any = {};

      /**
     * 获取订单数量
     * @private
     * @returns void
     */
     private async getOrderQuantity(): Promise<void>
    {
        try
        {
            let { content: result } = await OrderService.instance.getOrderQuantity();
            if(result.data)
            {
                this.hasRights = result.data.hasRights || false;
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
    private get userInfo(): any
    {
        let userInfoStorge = localStorage.getItem("userInfo");

        if (userInfoStorge)
        {
            return JSON.parse(userInfoStorge);
        }

        return {};
    }

    /**
     * 获取企业信息
     * @private
     * @returns any
     */
     private get orgInfo(): any
    {
        let orgInfoStorge = localStorage.getItem("orgInfo");
        if(orgInfoStorge)
        {
            return JSON.parse(orgInfoStorge)
        }
        return {};
    }

    /**
     * 判断是否登入
     * @private
     * @returns void
     */
    private onLogin(): boolean
    {
        if (!localStorage.getItem("userInfo"))
        {
            this.$router.push({name:"login", query:{redirect: location.href}});
            return true;
        }
    }

    /**
     * 跳转页面
     * @private
     * @returns void
     */
    private onGopage(name: string): void
    {
        if (this.onLogin())
        {
            return;
        }
        this.$router.push({name});
    }

    /**
     * 值发生变化
     * @protected
     * @returns void
     */
     @Watch("data", {immediate: true, deep: true})
    private onDataChange(newValue: any): void
    {
        // 背景样式
        this.pageStyle = {
            'margin': newValue.properties.moduleSettings.upAndDown + 'px 0 0 0', 
            'background-color': newValue.properties.moduleSettings.navigateBgcolor,
        };

        // 主标题字体大小
        this.titleText = {
            'font-size': newValue.properties.moduleSettings.titleFont + 'px'
        }

        // 副标题字体大小
        this.subTitleText = {
            'font-size': newValue.properties.moduleSettings.subTitleFont + 'px'
        }

        this.keyNum++;
    }
}
